var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSend = function SvgSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.149 1.58a.66.66 0 0 0-.078-.537.68.68 0 0 0-.419-.298.673.673 0 0 0-.37.021l-.015.005L.852 5.466a.67.67 0 0 0-.05 1.248l5.806 2.58 2.581 5.808a.671.671 0 0 0 1.247-.051l4.696-13.415a.774.774 0 0 0 .018-.055h-.001Zm-8.18 6.405-4.075-1.81 9.053-3.17-4.979 4.98Zm5.928-4.03-3.17 9.053-1.81-4.074 4.98-4.979Z"
  })));
};
export default SvgSend;